import React from "react";

export const Chips = ({ selected, disabled, children, onClick }) => {
  return (
    <div
      className={`
        py-ride-gl-spacing-large 
        px-ride-gl-spacing-xlarge 
        rounded-ride-sys-border-radius-container-medium
        flex
        items-center
        lg:px-ride-gl-spacing-2xlarge
        ${
          selected
            ? "border-2 border-ride-sys-color-border-extreme bg-ride-sys-color-surface-moderate"
            : "border border-ride-sys-color-border-default"
        }
        ${disabled ? "cursor-not-allowed" : "cursor-pointer"}
      `}
      onClick={() => !disabled && onClick()}
    >
      <span className="ride-sys-text-title-medium-default lg:ride-sys-text-paragraph-large-bold-short">{children}</span>
    </div>
  );
};
